<template>
	<div>
		<el-table :data="tableData"
				:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
				style="width: 100%;" :cell-style="{'text-align':'center'}">
			<el-table-column prop="no" label="序号" min-width="80"></el-table-column>
			<el-table-column prop="year" label="评选年度" min-width="100"></el-table-column>
			<el-table-column prop="content.project_title" label="课题名称" show-overflow-tooltip
				min-width="120"></el-table-column>
			<el-table-column prop="user.name" label="申报单位" show-overflow-tooltip min-width="120"></el-table-column>
			<el-table-column min-width="280" label="审核">
				<template slot-scope="scope">
					<el-button  v-if="scope.row.status==1||scope.row.status==2||scope.row.status==3" size="mini" @click="$emit('reject', scope.$index, scope.row)"
						style="background: #F53B3B;border-radius: 4px 4px 4px 4px;color: white;"
						icon="el-icon-close">驳回</el-button>
					<el-button  v-if="scope.row.status==1" @click="$emit('assign', scope.row)" size="mini"
						style="color: #FAA24B;border-radius: 4px 4px 4px 4px;border: 1px solid #FAA24B;">分配专家
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-tabs style="" v-model="activeName" tab-position="top">
			<el-tab-pane label="基本信息" name="basic">
				<div class="form_1" id="Contractorinfo">
					<div class="form_box_content">
						<div class="flex">
							<div class="my_form2">
								<div class="form_title" style="">企业名称</div>
								<div class="form_content">
									{{parameters.company}}
								</div>
								<div class="form_title" style="">小组名称</div>
								<div class="form_long">
									{{parameters.group}}
								</div>
							</div>
						</div>
						<div class="flex">
							<div class="my_form2">
								<div class="form_title" style="">小组人数</div>
								<div class="form_content">
									{{parameters.group_people_num}}
								</div>
								<div class="form_title" style="">小组成员</div>
								<div class="form_long">
									{{parameters.group_people}}
								</div>
							</div>
						</div>
						<div class="flex">
							<div class="my_form2">
								<div class="form_title" style="">课题名称</div>
								<div class="form_content">
									<div class="input">
										{{parameters.project_title}}
									</div>
								</div>
								<div class="form_title" style="">课题类型</div>
								<div class="form_content">
									<div class="input">
										{{parameters.project_type}}
									</div>
								</div>
							</div>
						</div>
						<div class="flex">
							<div class="my_form2">
								<div class="form_title" style="">小组活动结束时间</div>
								<div class="form_content">
									<div class="input">
										{{parameters.end_time}}
									</div>
								</div>
								<div class="form_title" style="">指导者/推进者证书有效期</div>
								<div class="form_content">
									<div class="input">
										{{parameters.guide_expire_date}}
									</div>
								</div>
							</div>
						</div>
						<div class="flex">
							<div class="my_form2">
								<div class="form_title" style="">指导者/推进者格证书颁发机构</div>
								<div class="form_content">
									<div class="input">
										{{parameters.guide_org}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="申报材料" name="nine">
				<el-table :data="applyFileList"
							:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
							style="width: 100%;" :cell-style="{'text-align':'center'}">
					<el-table-column prop="" label="序号" min-width="40">
						<template slot-scope="scope">
							<span v-text="getIndex(scope.$index)"> </span>
						</template>
					</el-table-column>
					<el-table-column label="资料名称" show-overflow-tooltip min-width="200">
						<template slot-scope="scope">
							<span>{{scope.row.name}}</span>
						</template>
					</el-table-column>
					<el-table-column min-width="100" label="操作">
						<template slot-scope="scope">
							<a class="a01" :href="scope.row.url" target="_blank">查看详情</a>
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
export default {
    props: {
		tableData: {
			type: Array,
			default: () => []
		},
		parameters: {
			type: Object, 
			default: () => ({})
		},
		model: {
			type: Object,
			default: () => ({})
		},
	},
	data() {
		return {
			activeName: 'basic',
		}
	},
	computed: {
		content() {
			return this.model.content || {}
		},
		applyFileList() {
			const content = this.content
			const allFileList = []
			function pushFile(fileList) {
				(fileList || []).forEach(file => {
					if (file) {
						allFileList.push({
							name: file.name,
							url: file.url
						})
					}
				})
			}
			pushFile(content.reportforms)
			pushFile(content.reportfiles)
			pushFile(content.reportinfos)
			pushFile(content.guidecerts)
			return allFileList
		}
	},
	methods: {
		getIndex($index) {
			return $index + 1;
		},
	}
}
</script>

<style lang="less" scoped>
.flex {
	display: flex;
	align-items: center;
}
.my_form,
.my_form2 {
	width: 100%;
	height: 100%;
	display: flex;
	overflow: visible;
	align-items: stretch;
	margin-bottom: 30px;
	.form_title {
		width: 120px;
		min-width: 120px;
		height: auto;
		display: flex;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #808895;
		margin-right: 5px;
		text-align:left;
	}
	.form_content {
		color:#323232;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		position: relative;
		padding-right: 6px;
		text-align:left;
		width: 265px;
	}
}
</style>